import classNames from 'classnames';
import { Collapse } from '@mui/material';
import { useCallback, useState } from 'react';
import { ChevronDownIcon } from 'app/agriculture/icons';
import './ContentBoxCollapse.scss';

interface ContentBoxCollapseProps {
    className?: string;
    children?: React.ReactNode;
}

export function ContentBoxCollapse({ className, children }: ContentBoxCollapseProps) {
    const [expanded, setExpanded] = useState(false);

    const handleClick = useCallback(() => {
        setExpanded((expanded) => !expanded);
    }, []);

    return (
        <div
            className={classNames(className, 'ContentBox__collapse', {
                'ContentBox__collapse--expanded': expanded,
            })}
        >
            <Collapse in={expanded} classes={{ wrapperInner: 'ContentBox__collapse__inner' }}>
                {children}
            </Collapse>
            <button onClick={handleClick} className="ContentBox__collapse__button">
                <div className="ContentBox__collapse__text">
                    <label>{expanded ? 'Less Details' : 'More Details'}</label>
                    <ChevronDownIcon className="ContentBox__collapse__icon" />
                </div>
            </button>
        </div>
    );
}
